import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=69966a7f&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"
import style0 from "./Contato.vue?vue&type=style&index=0&id=69966a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69966a7f",
  null
  
)

export default component.exports